import FuseAnimate from "../fuse-animate/fuse-animate";
import {Card, Hidden} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    header: {
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    balance: {
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'space-around',
        },
        [theme.breakpoints.up('md')]: {
            justifyContent: 'space-between',
        },
        fontSize: 24,
        fontWeight: 700,
    },
    linkButton: {
        marginTop: 24,
    },
    sideLinkButton: {
        minWidth: 180,
    },
}));

const BalanceCard = ({ account: {balance, status}, animation, delay }) => {
    //console.log('BalanceCard: balance =', balance, 'status =', status);
    const classes = useStyles();

    // The initials are used as a fallback for the avatar if the user hasn't selected one.
    const displayBalance = '$' + (balance/100).toFixed(2);

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="balance-card" className={classes.root}>

                <Grid item container className={classes.header}>
                    <Grid item>
                        <Typography variant="h6" color="secondary">Account Balance</Typography>
                    </Grid>
                    <Grid item>
                        <CreditStatus status={status} balance={balance}/>
                    </Grid>
                </Grid>

                <Grid container>

                    <Grid item container className={classes.balance}>
                        <Grid item>{displayBalance}</Grid>

                        <Hidden smDown>
                            <Grid item>
                                <Button variant="outlined"
                                        color="primary"
                                        size="large"
                                        component={Link}
                                        to="/recharge"
                                        className={classes.sideLinkButton}
                                        disabled={status < 1}
                                >Add Credit</Button>
                            </Grid>
                        </Hidden>
                    </Grid>

                </Grid>

                { status === 1 ?
                    <Hidden mdUp>
                        <Button variant="outlined"
                                color="primary"
                                size="large"
                                component={Link}
                                to="/recharge"
                                className={classes.linkButton}
                        >Add Credit</Button>
                    </Hidden>
                    : null
                }

            </Card>
        </FuseAnimate>
    )
}


const CreditStatus = ({status, balance}) => {

    let state = {
        status: '',
        bgColor: ''
    };

    if (balance > 0) {
        if (status === 0) {
            state = {status: 'Suspended', bgColor: red[700]}
        } else {
            state = {status: 'Active', bgColor: '#237a23'}
        }
    } else {
        state = {status: 'No credit', bgColor: red[700]}
    }

    const classes =  {
        textBox : {
            color: 'white',
            backgroundColor: state.bgColor,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 11,
            fontWeight: 500,
            borderRadius: 2
        }
    };

    return (
        <div style={classes.textBox}> {state.status} </div>
    )

}

export default BalanceCard;